import { render } from "./ViewMyRestaurants.vue?vue&type=template&id=05071475&scoped=true"
import script from "./ViewMyRestaurants.vue?vue&type=script&lang=js"
export * from "./ViewMyRestaurants.vue?vue&type=script&lang=js"

import "./ViewMyRestaurants.vue?vue&type=style&index=0&id=05071475&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05071475"]])

export default __exports__